import { Loader } from "@googlemaps/js-api-loader"

export const loader = new Loader({
  // @ts-ignore
  // apiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY, 
  apiKey: "AIzaSyCHVvHWxJQuySKasgsOuwnDneeAZsn7gZc", // ToDo: fix vite env variable import 
  version: "weekly",
  libraries: ["places"],
})
